import React from "react";
import {
  Home as HomeIcon,
  Map as MapIcon,
  Warning as WarningIcon,
  Visibility as VisibilityIcon,
  Assignment as AssignmentIcon,
  Assessment as AssessmentIcon,
  AutoAwesome as AutoAwesomeIcon,
  Router as RouterIcon,
  Settings as SettingsIcon,
  People as PeopleIcon,
  Send as SendIcon,
} from "@mui/icons-material";
import { ROUTES } from "../utils";

export interface NavigationItem {
  label: string;
  icon: React.ReactNode;
  path: string;
  comingSoon?: boolean;
  isHiddenInNavigation?: boolean;
  items?: NavigationItem[];
}

export interface NavigationSection {
  title: string;
  smallTitle?: string | null;
  subtitle: string;
  icon: React.ReactNode;
  iconColor: string;
  category?: string | null;
  items: NavigationItem[];
}

export const navigationSections: NavigationSection[] = [
  {
    title: "Overview",
    smallTitle: null,
    subtitle: "",
    icon: <HomeIcon />,
    iconColor: "#1976d2",
    category: null,
    items: [
      {
        label: "Dashboard",
        icon: <HomeIcon fontSize="small" />,
        path: ROUTES.DASHBOARD,
      },
      {
        label: "Geospatial",
        icon: <MapIcon fontSize="small" />,
        path: ROUTES.GEOSPATIAL,
      },
    ],
  },
  {
    title: "Operations",
    smallTitle: "Operations",
    subtitle: "",
    icon: <WarningIcon />,
    iconColor: "#d32f2f",
    category: "OPERATIONS",
    items: [
      {
        label: "Risks & Alerts",
        icon: <WarningIcon fontSize="small" />,
        path: ROUTES.RISKS,
      },
      {
        label: "Sightings",
        icon: <VisibilityIcon fontSize="small" />,
        path: ROUTES.SIGHTINGS,
      },
      {
        label: "Work Orders",
        icon: <AssignmentIcon fontSize="small" />,
        path: ROUTES.WORK_ORDERS,
      },
      {
        label: "Dispatch",
        icon: <SendIcon fontSize="small" />,
        path: ROUTES.DISPATCH,
      },
    ],
  },
  {
    title: "Network",
    smallTitle: "Network",
    subtitle: "",
    icon: <RouterIcon />,
    iconColor: "#2e7d32",
    category: "NETWORK",
    items: [
      {
        label: "Nodes",
        icon: <RouterIcon fontSize="small" />,
        path: ROUTES.NODES,
      },
    ],
  },
  {
    title: "Intelligence",
    smallTitle: "Intelligence",
    subtitle: "",
    icon: <AssessmentIcon />,
    iconColor: "#7b1fa2",
    category: "INTELLIGENCE",
    items: [
      {
        label: "Reports",
        icon: <AssessmentIcon fontSize="small" />,
        path: ROUTES.REPORTS,
      },
      {
        label: "AI Assistant",
        icon: <AutoAwesomeIcon fontSize="small" />,
        path: ROUTES.AI_ASSISTANT,
      },
    ],
  },
  {
    title: "Administration",
    smallTitle: "Admin",
    subtitle: "",
    icon: <SettingsIcon />,
    iconColor: "#616161",
    category: "ADMIN",
    items: [
      {
        label: "Users",
        icon: <PeopleIcon fontSize="small" />,
        path: ROUTES.USERS,
      },
      {
        label: "Settings",
        icon: <SettingsIcon fontSize="small" />,
        path: ROUTES.SETTINGS,
      },
    ],
  },
];
